module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB4SURBVHgBxZPRCcAgDETP4iDZsZTOUEpnbDZpEfyShJyC7QN/NMqRZ4BOjvO6y2r3M/oRazPV1yW6vW9rqoke41gX/EVJZKUa6ZFSVZ6VCCuRYIAcWXMstUy05lmJsHqkmAFrkflHQtT4sxbMVsuHs8ZaZHqkRA1eEnk3BRvScikAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/pri_filter_icon.png
// module id = 57
// module chunks = 1